import React from 'react';
import NinjaGame from '../NinjaGame';
import { ALL_DRILLS } from '../DrillConstants';

const FullTest = () => {
    const idx = ALL_DRILLS.findIndex(d => d.id === 'full');
    return <NinjaGame initialDrillIndex={idx} />;
};

export default FullTest;
